import React from 'react'
import { Navbar, Nav, NavItem, NavDropdown, Dropdown, Container } from 'react-bootstrap'
import { redirectHomepage } from 'loginControl'
import { connect } from 'react-redux'
import { changeApplication, signOut } from 'actions/rootActions'
import { unMimicUser, getMimicStatus } from 'actions/mimicActions'
import NavLinkContainer from 'sharedComponents/NavLinkContainer'
import { teamPageAccessAllowed } from 'applications/Settings/views/SharedAccounts/teamPagePermissions'
import { getMimicTokenFromCookie, redirectAfterUnmimic } from 'modules/mimicToken'
import Logo from '../../assets/images/payhelm-logo-blue.png'
import aiSparkle from './ai.png'
import './loader.css'

@connect(
  (store) => ({
    currentApp: store.root.applicationId,
    accounts: store.root.accounts,
    topUrl: store.root.topUrl,
    mimicStatus: store.mimic.mimic.status,
    subscriptionActive: store.plan.subscriptionActive,
    upgradeDismissed: store.plan.upgradeDismissed,
    sessionSignature: store.root.sessionSignature,
    customerBalance: store.plan.customerBalance,
    progressBar: store.dashboard.progressBar,
    fetching: store.dashboard.fetching,
    inventoryLoading: store.inventory.inventoryLoading,
  }),
  { changeApplication, unMimicUser, getMimicStatus, signOut }
)
export default class NavbarHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      progressBar: null,
    }
  }

  /**
   * Sign out and redirect to www homepage
   */
  signOut = () => {
    this.props.signOut().then(() => {
      redirectHomepage('You have signed out', 'info')
    })
  }

  unMimic() {
    const token = getMimicTokenFromCookie()
    if (!token) return
    this.props.unMimicUser(token).then(() => {
      redirectAfterUnmimic('/users')
    })
  }

  componentDidMount() {
    const token = getMimicTokenFromCookie()
    if (token) {
      this.props.getMimicStatus(token)
    }
  }

  /**
   * On select callback for nav items
   * @param {String} nextApp name of the clicked app
   */
  onSelect = (nextApp) => {
    this.props.changeApplication(this.props.currentApp, nextApp)
  }

  render() {
    const {
      subscriptionActive,
      upgradeDismissed,
      hasAccounts,
      sessionSignature,
      customerBalance,
      progressBar,
      accessPermissions: accessPermissionsProp,
      fetching,
      inventoryLoading,
      isLite,
    } = this.props
    const accessPermissions = accessPermissionsProp || {}
    const planNavAllowed = teamPageAccessAllowed(accessPermissions, 'plan')
    const shopifyAccess = this.props.topUrl && this.props.topUrl.includes('.myshopify.')
    const hasPaypalLogin = !!this.props.accounts.find((account) => account.channel === 'Paypal')
    const status = this.props.mimicStatus

    // Only show balance if customer has one - no need to reserve space if they never will have one
    let showBalance = customerBalance ? <span className="pr1">${customerBalance.toFixed(2)}</span> : null
    // Single variable for showing nav items - prevents layout shift by keeping condition consistent
    const showNavItems = (subscriptionActive || isLite || upgradeDismissed || status) && hasAccounts
    return (
      <>
        <Navbar bsPrefix="navbar" fixed="top" bg="light" expand="lg">
          <Navbar.Brand>
            <a href="/home">
              <img src={Logo} style={{ padding: 10, height: 49 }} fetchPriority="high" decoding="async" alt="PayHelm" />
            </a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse style={{ height: 52, position: 'relative' }}>
            {/* Always render Nav to prevent layout shift - items inside conditionally render */}
            {/* Use single variable for consistent condition checking */}
            <Nav activeKey={this.props.currentApp} className="full-height" style={{ flex: 1 }}>
              {showNavItems ? (
                  <Nav.Item as="li" key="dashboard" className="full-height">
                    <Nav.Link
                      href="/dashboard"
                      eventKey="dashboard"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer to="/dashboard" onClick={() => this.onSelect('dashboard')} type="nav-item">
                        Dashboard
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item key="traffic" as="li" className="full-height">
                    <Nav.Link
                      href="/traffic"
                      eventKey="traffic"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer to="/traffic" onClick={() => this.onSelect('traffic')} type="nav-item">
                        Traffic
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item as="li" key="reports" className="full-height">
                    <Nav.Link
                      href="/reports"
                      eventKey="reports"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer to="/reports" onClick={() => this.onSelect('reports')} type="nav-item">
                        Reports
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item key="integrations" as="li" className="full-height">
                    <Nav.Link
                      href="/integrations"
                      eventKey="integrations"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer
                        to="/integrations"
                        onClick={() => this.onSelect('integrations')}
                        type="nav-item"
                      >
                        Integrations
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item as="li" key="custom" className="full-height">
                    <Nav.Link
                      href="/custom"
                      eventKey="custom"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer to="/custom" onClick={() => this.onSelect('custom')} type="nav-item">
                        Custom Reports
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item key="AI" as="li" className="full-height">
                    <Nav.Link href="/ai" eventKey="AI" className="full-height flex-box justify-center align-center">
                      <NavLinkContainer to="/ai" onClick={() => this.onSelect('AI')} type="nav-item">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span className="try-badge">
                            <img src={aiSparkle} alt="sparkle" className="try-badge-sparkle" />
                            Try!
                          </span>
                          AI Chat
                        </div>
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item as="li" key="emailcampaigns" className="full-height">
                    <Nav.Link
                      href="/emailcampaigns"
                      eventKey="emailcampaigns"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer
                        to="/emailcampaigns"
                        onClick={() => this.onSelect('emailcampaigns')}
                        type="nav-item"
                      >
                        Email Campaigns
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item as="li" key="shipping" className="full-height">
                    <Nav.Link
                      href="/shipping/orders"
                      eventKey="shipping"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer
                        to="/shipping/orders"
                        onClick={() => this.onSelect('shipping')}
                        type="nav-item"
                      >
                        Shipping
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
                {showNavItems ? (
                  <Nav.Item key="inventory" as="li" className="full-height">
                    <Nav.Link
                      href="/inventory"
                      eventKey="inventory"
                      className="full-height flex-box justify-center align-center"
                    >
                      <NavLinkContainer to="/inventory" onClick={() => this.onSelect('inventory')} type="nav-item">
                        Inventory
                      </NavLinkContainer>
                    </Nav.Link>
                  </Nav.Item>
                ) : null}
            </Nav>

            {/* Mobile: Show menu items inline in collapsed menu (hidden on desktop) */}
            <Nav className="d-lg-none flex-column" style={{ borderTop: '1px solid #e9ecef', marginTop: '8px', paddingTop: '8px' }}>
              {planNavAllowed ? (
                <Nav.Item>
                  <Nav.Link href="/plan" eventKey="plan" className="text-center py-2">
                    <NavLinkContainer to="/plan" onClick={() => this.onSelect('plan')} type="nav-item">
                      My Plan
                    </NavLinkContainer>
                  </Nav.Link>
                </Nav.Item>
              ) : null}
              <Nav.Item>
                <Nav.Link href="/settings" eventKey="settings" className="text-center py-2">
                  <NavLinkContainer to="/settings" onClick={() => this.onSelect('settings')} type="nav-item">
                    Settings
                  </NavLinkContainer>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  href="https://www.payhelm.com/help/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-center py-2"
                >
                  Support
                </Nav.Link>
              </Nav.Item>
              {status ? (
                <Nav.Item>
                  <Nav.Link onClick={() => this.unMimic()} className="text-center py-2">
                    Unmimic
                  </Nav.Link>
                </Nav.Item>
              ) : null}
              {shopifyAccess || sessionSignature ? null : (
                <Nav.Item>
                  <Nav.Link onClick={this.signOut} className="text-center py-2" style={{ color: '#dc3545' }}>
                    Sign out
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>

            <Nav className="d-none d-lg-flex mr2" style={{ flexShrink: 0 }}>
              <NavDropdown
                key={3}
                title={
                  <>
                    {showBalance}
                    <span className="fa fa-user-circle" />
                  </>
                }
                id="basic-nav-dropdown"
                align="end"
              >
                {planNavAllowed ? (
                  <Dropdown.Item eventKey="plan" active={this.props.currentApp === 'plan'} href="/plan">
                    <NavLinkContainer to="/plan" onClick={() => this.onSelect('plan')} type="nav-dropdown">
                      <div
                        className="flex-box"
                        style={this.props.currentApp === 'plan' ? { backgroundColor: '#0D6EFD' } : null}
                      >
                        <span className="flex-1">My Plan</span>
                        <span>
                          <span className="fa fa-columns mr01" />
                        </span>
                      </div>
                    </NavLinkContainer>
                  </Dropdown.Item>
                ) : null}
                <Dropdown.Item eventKey="settings" active={this.props.currentApp === 'settings'} href="/settings">
                  <NavLinkContainer to="/settings" onClick={() => this.onSelect('settings')} type="nav-dropdown">
                    <div
                      className="flex-box"
                      style={this.props.currentApp === 'settings' ? { backgroundColor: '#0D6EFD' } : null}
                    >
                      <span className="flex-1">Settings</span>
                      <span>
                        <span className="fa fa-cog mr01" />
                      </span>
                    </div>
                  </NavLinkContainer>
                </Dropdown.Item>
                <Dropdown.Item eventKey="faq" active={this.props.currentApp === 'faq'} href="/faq">
                  <a
                    href="https://www.payhelm.com/help/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div className="flex-box">
                      <span className="flex-1">Support</span>
                      <span>
                        <span className="fa fa-question-circle mr01" />
                      </span>
                    </div>
                  </a>
                </Dropdown.Item>
                {status ? (
                  <Dropdown.Item eventKey={3.4} onClick={() => this.unMimic()}>
                    <div className="flex-box">
                      <span className="flex-1">Unmimic</span>
                      <span>
                        <span className="fa fa-ban mr01" />
                      </span>
                    </div>
                  </Dropdown.Item>
                ) : null}
                {shopifyAccess || sessionSignature ? null : <Dropdown.Divider />}
                {shopifyAccess || sessionSignature ? null : (
                  <Dropdown.Item eventKey={3.3} onClick={this.signOut}>
                    <div className="flex-box">
                      <span className="flex-1">Sign out</span>
                      <span>
                        <span className="fa fa-sign-out mr01" />
                      </span>
                    </div>
                  </Dropdown.Item>
                )}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {progressBar && (
          <div className="meter blue">
            <span style={{ width: '100%' }} />
          </div>
        )}
        {fetching.order && !progressBar && (
          <div className="meter blue">
            <span style={{ width: '100%' }} />
          </div>
        )}
        {inventoryLoading && (
          <div className="meter blue">
            <span style={{ width: '100%' }} />
          </div>
        )}
      </>
    )
  }
}
